import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy-policy")({
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  const effectiveDate = "May 23, 2026";

  return (
    <main className="min-h-screen bg-zinc-50 px-4 py-10 text-zinc-900">
      <div className="mx-auto w-full max-w-3xl rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm md:p-10">
        <h1 className="text-3xl font-bold tracking-tight">Privacy Policy</h1>
        <p className="mt-2 text-sm text-zinc-500">Effective date: {effectiveDate}</p>

        <section className="mt-8 space-y-3 text-sm leading-6 text-zinc-700">
          <h2 className="text-lg font-semibold text-zinc-900">1. Information We Collect</h2>
          <p>
            We may collect information you provide directly, such as locations you search,
            route preferences, feedback submissions, and basic contact information when you
            choose to share it.
          </p>
          <p>
            We also collect limited technical data, such as device type, browser, and
            anonymized usage analytics, to improve reliability and user experience.
          </p>
        </section>

        <section className="mt-8 space-y-3 text-sm leading-6 text-zinc-700">
          <h2 className="text-lg font-semibold text-zinc-900">2. How We Use Data</h2>
          <p>
            We use your data to provide route planning features, improve map quality,
            troubleshoot issues, and understand product usage trends.
          </p>
        </section>

        <section className="mt-8 space-y-3 text-sm leading-6 text-zinc-700">
          <h2 className="text-lg font-semibold text-zinc-900">3. Sharing</h2>
          <p>
            We do not sell your personal data. We may share limited information with trusted
            service providers that help us run the platform, subject to confidentiality and
            security obligations.
          </p>
        </section>

        <section className="mt-8 space-y-3 text-sm leading-6 text-zinc-700">
          <h2 className="text-lg font-semibold text-zinc-900">4. Retention and Security</h2>
          <p>
            We retain data only as long as needed for service delivery, legal compliance, and
            product improvement. We use reasonable safeguards to protect information in transit
            and at rest.
          </p>
        </section>

        <section className="mt-8 space-y-3 text-sm leading-6 text-zinc-700">
          <h2 className="text-lg font-semibold text-zinc-900">5. Your Choices</h2>
          <p>
            You can control location permissions through your device or browser settings.
            You may also contact us to request access, correction, or deletion of data where
            applicable law provides those rights.
          </p>
        </section>

        <section className="mt-8 space-y-3 text-sm leading-6 text-zinc-700">
          <h2 className="text-lg font-semibold text-zinc-900">6. Contact</h2>
          <p>
            For privacy questions, contact us at
            <a className="ml-1 text-zinc-900 underline" href="mailto:hello@trotroways.com">
              hello@trotroways.com
            </a>
            .
          </p>
        </section>
      </div>
    </main>
  );
}
